const allTimezones = [
  { value: "Pacific/Niue", title: "(GMT-11:00) Niue" },
  { value: "Pacific/Pago_Pago", title: "(GMT-11:00) Pago Pago" },
  { value: "Pacific/Honolulu", title: "(GMT-10:00) Hawaii Time" },
  { value: "Pacific/Rarotonga", title: "(GMT-10:00) Rarotonga" },
  { value: "Pacific/Tahiti", title: "(GMT-10:00) Tahiti" },
  { value: "Pacific/Marquesas", title: "(GMT-09:30) Marquesas" },
  { value: "America/Anchorage", title: "(GMT-09:00) Alaska Time" },
  { value: "Pacific/Gambier", title: "(GMT-09:00) Gambier" },
  { value: "America/Los_Angeles", title: "(GMT-08:00) Pacific Time" },
  { value: "America/Tijuana", title: "(GMT-08:00) Pacific Time - Tijuana" },
  { value: "America/Vancouver", title: "(GMT-08:00) Pacific Time - Vancouver" },
  {
    value: "America/Whitehorse",
    title: "(GMT-08:00) Pacific Time - Whitehorse",
  },
  { value: "Pacific/Pitcairn", title: "(GMT-08:00) Pitcairn" },
  {
    value: "America/Dawson_Creek",
    title: "(GMT-07:00) Mountain Time - Dawson Creek",
  },
  { value: "America/Denver", title: "(GMT-07:00) Mountain Time" },
  { value: "America/Edmonton", title: "(GMT-07:00) Mountain Time - Edmonton" },
  {
    value: "America/Hermosillo",
    title: "(GMT-07:00) Mountain Time - Hermosillo",
  },
  {
    value: "America/Mazatlan",
    title: "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan",
  },
  { value: "America/Phoenix", title: "(GMT-07:00) Mountain Time - Arizona" },
  {
    value: "America/Yellowknife",
    title: "(GMT-07:00) Mountain Time - Yellowknife",
  },
  { value: "America/Belize", title: "(GMT-06:00) Belize" },
  { value: "America/Chicago", title: "(GMT-06:00) Central Time" },
  { value: "America/Costa_Rica", title: "(GMT-06:00) Costa Rica" },
  { value: "America/El_Salvador", title: "(GMT-06:00) El Salvador" },
  { value: "America/Guatemala", title: "(GMT-06:00) Guatemala" },
  { value: "America/Managua", title: "(GMT-06:00) Managua" },
  {
    value: "America/Mexico_City",
    title: "(GMT-06:00) Central Time - Mexico City",
  },
  { value: "America/Regina", title: "(GMT-06:00) Central Time - Regina" },
  {
    value: "America/Tegucigalpa",
    title: "(GMT-06:00) Central Time - Tegucigalpa",
  },
  { value: "America/Winnipeg", title: "(GMT-06:00) Central Time - Winnipeg" },
  { value: "Pacific/Galapagos", title: "(GMT-06:00) Galapagos" },
  { value: "America/Bogota", title: "(GMT-05:00) Bogota" },
  { value: "America/Cancun", title: "(GMT-05:00) America Cancun" },
  { value: "America/Cayman", title: "(GMT-05:00) Cayman" },
  { value: "America/Guayaquil", title: "(GMT-05:00) Guayaquil" },
  { value: "America/Havana", title: "(GMT-05:00) Havana" },
  { value: "America/Iqaluit", title: "(GMT-05:00) Eastern Time - Iqaluit" },
  { value: "America/Jamaica", title: "(GMT-05:00) Jamaica" },
  { value: "America/Lima", title: "(GMT-05:00) Lima" },
  { value: "America/Nassau", title: "(GMT-05:00) Nassau" },
  { value: "America/New_York", title: "(GMT-05:00) Eastern Time" },
  { value: "America/Panama", title: "(GMT-05:00) Panama" },
  { value: "America/Port-au-Prince", title: "(GMT-05:00) Port-au-Prince" },
  { value: "America/Rio_Branco", title: "(GMT-05:00) Rio Branco" },
  { value: "America/Toronto", title: "(GMT-05:00) Eastern Time - Toronto" },
  { value: "Pacific/Easter", title: "(GMT-05:00) Easter Island" },
  { value: "America/Caracas", title: "(GMT-04:30) Caracas" },
  { value: "America/Asuncion", title: "(GMT-03:00) Asuncion" },
  { value: "America/Barbados", title: "(GMT-04:00) Barbados" },
  { value: "America/Boa_Vista", title: "(GMT-04:00) Boa Vista" },
  { value: "America/Campo_Grande", title: "(GMT-03:00) Campo Grande" },
  { value: "America/Cuiaba", title: "(GMT-03:00) Cuiaba" },
  { value: "America/Curacao", title: "(GMT-04:00) Curacao" },
  { value: "America/Grand_Turk", title: "(GMT-04:00) Grand Turk" },
  { value: "America/Guyana", title: "(GMT-04:00) Guyana" },
  { value: "America/Halifax", title: "(GMT-04:00) Atlantic Time - Halifax" },
  { value: "America/La_Paz", title: "(GMT-04:00) La Paz" },
  { value: "America/Manaus", title: "(GMT-04:00) Manaus" },
  { value: "America/Martinique", title: "(GMT-04:00) Martinique" },
  { value: "America/Port_of_Spain", title: "(GMT-04:00) Port of Spain" },
  { value: "America/Porto_Velho", title: "(GMT-04:00) Porto Velho" },
  { value: "America/Puerto_Rico", title: "(GMT-04:00) Puerto Rico" },
  { value: "America/Santo_Domingo", title: "(GMT-04:00) Santo Domingo" },
  { value: "America/Thule", title: "(GMT-04:00) Thule" },
  { value: "Atlantic/Bermuda", title: "(GMT-04:00) Bermuda" },
  {
    value: "America/St_Johns",
    title: "(GMT-03:30) Newfoundland Time - St. Johns",
  },
  { value: "America/Araguaina", title: "(GMT-03:00) Araguaina" },
  { value: "America/Argentina", title: "(GMT-03:00) Buenos Aires" },
  { value: "America/Bahia", title: "(GMT-03:00) Salvador" },
  { value: "America/Belem", title: "(GMT-03:00) Belem" },
  { value: "America/Cayenne", title: "(GMT-03:00) Cayenne" },
  { value: "America/Fortaleza", title: "(GMT-03:00) Fortaleza" },
  { value: "America/Godthab", title: "(GMT-03:00) Godthab" },
  { value: "America/Maceio", title: "(GMT-03:00) Maceio" },
  { value: "America/Miquelon", title: "(GMT-03:00) Miquelon" },
  { value: "America/Montevideo", title: "(GMT-03:00) Montevideo" },
  { value: "America/Paramaribo", title: "(GMT-03:00) Paramaribo" },
  { value: "America/Recife", title: "(GMT-03:00) Recife" },
  { value: "America/Santiago", title: "(GMT-03:00) Santiago" },
  { value: "America/Sao_Paulo", title: "(GMT-02:00) Sao Paulo" },
  { value: "Antarctica/Palmer", title: "(GMT-03:00) Palmer" },
  { value: "Antarctica/Rothera", title: "(GMT-03:00) Rothera" },
  { value: "Atlantic/Stanley", title: "(GMT-03:00) Stanley" },
  { value: "America/Noronha", title: "(GMT-02:00) Noronha" },
  { value: "Atlantic/South_Georgia", title: "(GMT-02:00) South Georgia" },
  { value: "America/Scoresbysund", title: "(GMT-01:00) Scoresbysund" },
  { value: "Atlantic/Azores", title: "(GMT-01:00) Azores" },
  { value: "Atlantic/Cape_Verde", title: "(GMT-01:00) Cape Verde" },
  { value: "Africa/Abidjan", title: "(GMT+00:00) Abidjan" },
  { value: "Africa/Accra", title: "(GMT+00:00) Accra" },
  { value: "Africa/Bissau", title: "(GMT+00:00) Bissau" },
  { value: "Africa/Casablanca", title: "(GMT+00:00) Casablanca" },
  { value: "Africa/El_Aaiun", title: "(GMT+00:00) El Aaiun" },
  { value: "Africa/Monrovia", title: "(GMT+00:00) Monrovia" },
  { value: "America/Danmarkshavn", title: "(GMT+00:00) Danmarkshavn" },
  { value: "Atlantic/Canary", title: "(GMT+00:00) Canary Islands" },
  { value: "Atlantic/Faroe", title: "(GMT+00:00) Faeroe" },
  { value: "Atlantic/Reykjavik", title: "(GMT+00:00) Reykjavik" },
  { value: "Etc/GMT", title: "(GMT+00:00) GMT (no daylight saving)" },
  { value: "Europe/Dublin", title: "(GMT+00:00) Dublin" },
  { value: "Europe/Lisbon", title: "(GMT+00:00) Lisbon" },
  { value: "Europe/London", title: "(GMT+00:00) London" },
  { value: "Africa/Algiers", title: "(GMT+01:00) Algiers" },
  { value: "Africa/Ceuta", title: "(GMT+01:00) Ceuta" },
  { value: "Africa/Lagos", title: "(GMT+01:00) Lagos" },
  { value: "Africa/Ndjamena", title: "(GMT+01:00) Ndjamena" },
  { value: "Africa/Tunis", title: "(GMT+01:00) Tunis" },
  { value: "Africa/Windhoek", title: "(GMT+02:00) Windhoek" },
  { value: "Europe/Amsterdam", title: "(GMT+01:00) Amsterdam" },
  { value: "Europe/Andorra", title: "(GMT+01:00) Andorra" },
  {
    value: "Europe/Belgrade",
    title: "(GMT+01:00) Central European Time - Belgrade",
  },
  { value: "Europe/Berlin", title: "(GMT+01:00) Berlin" },
  { value: "Europe/Brussels", title: "(GMT+01:00) Brussels" },
  { value: "Europe/Budapest", title: "(GMT+01:00) Budapest" },
  { value: "Europe/Copenhagen", title: "(GMT+01:00) Copenhagen" },
  { value: "Europe/Gibraltar", title: "(GMT+01:00) Gibraltar" },
  { value: "Europe/Luxembourg", title: "(GMT+01:00) Luxembourg" },
  { value: "Europe/Madrid", title: "(GMT+01:00) Madrid" },
  { value: "Europe/Malta", title: "(GMT+01:00) Malta" },
  { value: "Europe/Monaco", title: "(GMT+01:00) Monaco" },
  { value: "Europe/Oslo", title: "(GMT+01:00) Oslo" },
  { value: "Europe/Paris", title: "(GMT+01:00) Paris" },
  {
    value: "Europe/Prague",
    title: "(GMT+01:00) Central European Time - Prague",
  },
  { value: "Europe/Rome", title: "(GMT+01:00) Rome" },
  { value: "Europe/Stockholm", title: "(GMT+01:00) Stockholm" },
  { value: "Europe/Tirane", title: "(GMT+01:00) Tirane" },
  { value: "Europe/Vienna", title: "(GMT+01:00) Vienna" },
  { value: "Europe/Warsaw", title: "(GMT+01:00) Warsaw" },
  { value: "Europe/Zurich", title: "(GMT+01:00) Zurich" },
  { value: "Africa/Cairo", title: "(GMT+02:00) Cairo" },
  { value: "Africa/Johannesburg", title: "(GMT+02:00) Johannesburg" },
  { value: "Africa/Maputo", title: "(GMT+02:00) Maputo" },
  { value: "Africa/Tripoli", title: "(GMT+02:00) Tripoli" },
  { value: "Asia/Amman", title: "(GMT+02:00) Amman" },
  { value: "Asia/Beirut", title: "(GMT+02:00) Beirut" },
  { value: "Asia/Damascus", title: "(GMT+02:00) Damascus" },
  { value: "Asia/Gaza", title: "(GMT+02:00) Gaza" },
  { value: "Asia/Jerusalem", title: "(GMT+02:00) Jerusalem" },
  { value: "Asia/Nicosia", title: "(GMT+02:00) Nicosia" },
  { value: "Europe/Athens", title: "(GMT+02:00) Athens" },
  { value: "Europe/Bucharest", title: "(GMT+02:00) Bucharest" },
  { value: "Europe/Chisinau", title: "(GMT+02:00) Chisinau" },
  { value: "Europe/Helsinki", title: "(GMT+02:00) Helsinki" },
  { value: "Europe/Istanbul", title: "(GMT+02:00) Istanbul" },
  { value: "Europe/Kaliningrad", title: "(GMT+02:00) Moscow-01 - Kaliningrad" },
  { value: "Europe/Kiev", title: "(GMT+02:00) Kiev" },
  { value: "Europe/Riga", title: "(GMT+02:00) Riga" },
  { value: "Europe/Sofia", title: "(GMT+02:00) Sofia" },
  { value: "Europe/Tallinn", title: "(GMT+02:00) Tallinn" },
  { value: "Europe/Vilnius", title: "(GMT+02:00) Vilnius" },
  { value: "Africa/Khartoum", title: "(GMT+03:00) Khartoum" },
  { value: "Africa/Nairobi", title: "(GMT+03:00) Nairobi" },
  { value: "Antarctica/Syowa", title: "(GMT+03:00) Syowa" },
  { value: "Asia/Baghdad", title: "(GMT+03:00) Baghdad" },
  { value: "Asia/Qatar", title: "(GMT+03:00) Qatar" },
  { value: "Asia/Riyadh", title: "(GMT+03:00) Riyadh" },
  { value: "Europe/Minsk", title: "(GMT+03:00) Minsk" },
  { value: "Europe/Moscow", title: "(GMT+03:00) Moscow+00 - Moscow" },
  { value: "Asia/Tehran", title: "(GMT+03:30) Tehran" },
  { value: "Asia/Baku", title: "(GMT+04:00) Baku" },
  { value: "Asia/Dubai", title: "(GMT+04:00) Dubai" },
  { value: "Asia/Tbilisi", title: "(GMT+04:00) Tbilisi" },
  { value: "Asia/Yerevan", title: "(GMT+04:00) Yerevan" },
  { value: "Europe/Samara", title: "(GMT+04:00) Moscow+01 - Samara" },
  { value: "Indian/Mahe", title: "(GMT+04:00) Mahe" },
  { value: "Indian/Mauritius", title: "(GMT+04:00) Mauritius" },
  { value: "Indian/Reunion", title: "(GMT+04:00) Reunion" },
  { value: "Asia/Kabul", title: "(GMT+04:30) Kabul" },
  { value: "Antarctica/Mawson", title: "(GMT+05:00) Mawson" },
  { value: "Asia/Aqtau", title: "(GMT+05:00) Aqtau" },
  { value: "Asia/Aqtobe", title: "(GMT+05:00) Aqtobe" },
  { value: "Asia/Ashgabat", title: "(GMT+05:00) Ashgabat" },
  { value: "Asia/Dushanbe", title: "(GMT+05:00) Dushanbe" },
  { value: "Asia/Karachi", title: "(GMT+05:00) Karachi" },
  { value: "Asia/Tashkent", title: "(GMT+05:00) Tashkent" },
  {
    value: "Asia/Yekaterinburg",
    title: "(GMT+05:00) Moscow+02 - Yekaterinburg",
  },
  { value: "Indian/Kerguelen", title: "(GMT+05:00) Kerguelen" },
  { value: "Indian/Maldives", title: "(GMT+05:00) Maldives" },
  { value: "Asia/Calcutta", title: "(GMT+05:30) India Standard Time" },
  // exceptional case: guessed by firefox
  { value: "Asia/Kolkata", title: "(GMT+05:30) India Standard Time" },
  { value: "Asia/Colombo", title: "(GMT+05:30) Colombo" },
  { value: "Asia/Katmandu", title: "(GMT+05:45) Katmandu" },
  { value: "Antarctica/Vostok", title: "(GMT+06:00) Vostok" },
  { value: "Asia/Almaty", title: "(GMT+06:00) Almaty" },
  { value: "Asia/Bishkek", title: "(GMT+06:00) Bishkek" },
  { value: "Asia/Dhaka", title: "(GMT+06:00) Dhaka" },
  { value: "Asia/Omsk", title: "(GMT+06:00) Moscow+03 - Omsk, Novosibirsk" },
  { value: "Asia/Thimphu", title: "(GMT+06:00) Thimphu" },
  { value: "Indian/Chagos", title: "(GMT+06:00) Chagos" },
  { value: "Asia/Rangoon", title: "(GMT+06:30) Rangoon" },
  { value: "Indian/Cocos", title: "(GMT+06:30) Cocos" },
  { value: "Antarctica/Davis", title: "(GMT+07:00) Davis" },
  { value: "Asia/Bangkok", title: "(GMT+07:00) Bangkok" },
  { value: "Asia/Hovd", title: "(GMT+07:00) Hovd" },
  { value: "Asia/Jakarta", title: "(GMT+07:00) Jakarta" },
  { value: "Asia/Krasnoyarsk", title: "(GMT+07:00) Moscow+04 - Krasnoyarsk" },
  { value: "Asia/Saigon", title: "(GMT+07:00) Hanoi" },
  { value: "Asia/Ho_Chi_Minh", title: "(GMT+07:00) Ho Chi Minh" },
  { value: "Indian/Christmas", title: "(GMT+07:00) Christmas" },
  { value: "Antarctica/Casey", title: "(GMT+08:00) Casey" },
  { value: "Asia/Brunei", title: "(GMT+08:00) Brunei" },
  { value: "Asia/Choibalsan", title: "(GMT+08:00) Choibalsan" },
  { value: "Asia/Hong_Kong", title: "(GMT+08:00) Hong Kong" },
  { value: "Asia/Irkutsk", title: "(GMT+08:00) Moscow+05 - Irkutsk" },
  { value: "Asia/Kuala_Lumpur", title: "(GMT+08:00) Kuala Lumpur" },
  { value: "Asia/Macau", title: "(GMT+08:00) Macau" },
  { value: "Asia/Makassar", title: "(GMT+08:00) Makassar" },
  { value: "Asia/Manila", title: "(GMT+08:00) Manila" },
  { value: "Asia/Shanghai", title: "(GMT+08:00) China Time - Beijing" },
  { value: "Asia/Singapore", title: "(GMT+08:00) Singapore" },
  { value: "Asia/Taipei", title: "(GMT+08:00) Taipei" },
  { value: "Asia/Ulaanbaatar", title: "(GMT+08:00) Ulaanbaatar" },
  { value: "Australia/Perth", title: "(GMT+08:00) Western Time - Perth" },
  { value: "Asia/Pyongyang", title: "(GMT+08:30) Pyongyang" },
  { value: "Asia/Dili", title: "(GMT+09:00) Dili" },
  { value: "Asia/Jayapura", title: "(GMT+09:00) Jayapura" },
  { value: "Asia/Seoul", title: "(GMT+09:00) Seoul" },
  { value: "Asia/Tokyo", title: "(GMT+09:00) Tokyo" },
  { value: "Asia/Yakutsk", title: "(GMT+09:00) Moscow+06 - Yakutsk" },
  { value: "Pacific/Palau", title: "(GMT+09:00) Palau" },
  { value: "Australia/Adelaide", title: "(GMT+10:30) Central Time - Adelaide" },
  { value: "Australia/Darwin", title: "(GMT+09:30) Central Time - Darwin" },
  { value: "Antarctica/DumontDUrville", title: "(GMT+10:00) Dumont D'Urville" },
  { value: "Asia/Magadan", title: "(GMT+10:00) Moscow+07 - Magadan" },
  {
    value: "Asia/Vladivostok",
    title: "(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk",
  },
  { value: "Australia/Brisbane", title: "(GMT+10:00) Eastern Time - Brisbane" },
  { value: "Australia/Hobart", title: "(GMT+11:00) Eastern Time - Hobart" },
  {
    value: "Australia/Sydney",
    title: "(GMT+11:00) Eastern Time - Melbourne, Sydney",
  },
  { value: "Pacific/Chuuk", title: "(GMT+10:00) Truk" },
  { value: "Pacific/Guam", title: "(GMT+10:00) Guam" },
  { value: "Pacific/Port_Moresby", title: "(GMT+10:00) Port Moresby" },
  { value: "Pacific/Efate", title: "(GMT+11:00) Efate" },
  { value: "Pacific/Guadalcanal", title: "(GMT+11:00) Guadalcanal" },
  { value: "Pacific/Kosrae", title: "(GMT+11:00) Kosrae" },
  { value: "Pacific/Norfolk", title: "(GMT+11:00) Norfolk" },
  { value: "Pacific/Noumea", title: "(GMT+11:00) Noumea" },
  { value: "Pacific/Pohnpei", title: "(GMT+11:00) Ponape" },
  {
    value: "Asia/Kamchatka",
    title: "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy",
  },
  { value: "Pacific/Auckland", title: "(GMT+13:00) Auckland" },
  { value: "Pacific/Fiji", title: "(GMT+13:00) Fiji" },
  { value: "Pacific/Funafuti", title: "(GMT+12:00) Funafuti" },
  { value: "Pacific/Kwajalein", title: "(GMT+12:00) Kwajalein" },
  { value: "Pacific/Majuro", title: "(GMT+12:00) Majuro" },
  { value: "Pacific/Nauru", title: "(GMT+12:00) Nauru" },
  { value: "Pacific/Tarawa", title: "(GMT+12:00) Tarawa" },
  { value: "Pacific/Wake", title: "(GMT+12:00) Wake" },
  { value: "Pacific/Wallis", title: "(GMT+12:00) Wallis" },
  { value: "Pacific/Apia", title: "(GMT+14:00) Apia" },
  { value: "Pacific/Enderbury", title: "(GMT+13:00) Enderbury" },
  { value: "Pacific/Fakaofo", title: "(GMT+13:00) Fakaofo" },
  { value: "Pacific/Tongatapu", title: "(GMT+13:00) Tongatapu" },
  { value: "Pacific/Kiritimati", title: "(GMT+14:00) Kiritimati" },
];

export default allTimezones;
